

import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ProgrammesPage from '../pages/programmes/page';
import NotFound from '../pages/NotFound';
import CorporateTrainingPage from '../pages/corporate-training/page';
import SETACompliancePage from '../pages/seta-compliance/page';
import TestimonialsPage from '../pages/testimonials/page';
import ResourcesPage from '../pages/resources/page';
import ContactPage from '../pages/contact/page';
import FAQPage from '../pages/faq/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/programmes',
    element: <ProgrammesPage />,
  },
  {
    path: '/corporate-training',
    element: <CorporateTrainingPage />
  },
  {
    path: '/seta-compliance',
    element: <SETACompliancePage />
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />
  },
  {
    path: '/resources',
    element: <ResourcesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
